/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.directives {
    export interface IReviewSectionScope extends ng.IScope {
        model: ReviewSectionModel;
        isConfigureMode: boolean;
        isEditMode: boolean;
        reviewConfiguration: Wars.Domain.Model.Reviews.ReviewConfiguration; 
        process: Wars.Domain.Model.Dtos.ProcessDto;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        processConfigurationId: string;
        manageSection: Wars.Domain.Model.ManageSection;
    }

    export class ReviewSection implements IDirective {
        public link($scope: IFieldSectionScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/manageForm/reviewSection.html';
        public controller = [
            '$scope', '$timeout', 'formService', 'reviewConfigurationService', 'userService', 'processService', 'commentService',
            'growl', 'dateRangeService', 'processDocumentService', ReviewSectionController
        ];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            reviewConfiguration: "=",
            process: "=",
            processConfiguration: "=",
            processConfigurationId: "=",
            manageSection: "="
        };
    }

    export class ReviewSectionModel {
        public selectedUser: any;
        selectedReviewUserId: string;
        currentReviewSet : Wars.Domain.Model.Dtos.ReviewSetDto;
        addingNewComment: boolean;
        newComment: string;
        newCommentDocIds: string[];
        newCommentDate: any;
        dueDate;
        selectedReviewType: Wars.Domain.Model.Codes.SystemCode;
        showAddReview: boolean;
        public assignedDate: any;
        public docIds: string[];
        errorMessage: string;
        typedInUserValue: string;

        public reviews: Wars.Domain.Model.Reviews.ReviewConfiguration[];
        public fileUploadModel: any;

        public updateReviewDocumentHandlers: any = {};

        public documentUpdated = (model: models.FileUploadModel) => this.documentUpdatedInternal(model);
 
        constructor(
            private $timeout: angular.ITimeoutService,
            private userService: services.UserService,
            private processService: services.ProcessService,
            private formService: services.FormService,
            private commentService: services.CommentService,
            private reviewConfigurationService: Services.ReviewConfigurationService,
            private processConfigurationId,
            public isConfigureMode: boolean,
            public manageSection: Wars.Domain.Model.ManageSection,
            private process: Wars.Domain.Model.Dtos.ProcessDto,
            private growl: angular.growl.IGrowlService,
            private dateRangeService: services.DateRangeService,
            private processDocumentService: services.ProcessDocumentService) {

            this.initialize();
        }

        private initialize() {
            if (this.isConfigureMode) {
                this.reviewConfigurationService.getReviewConfigurations(this.processConfigurationId).then(reviews => {
                    reviews.forEach(r => {
                        (<any>r).open = false;
                    });
                    this.reviews = reviews;
                });
            } else {
                for (let reviewSetIndex = 0; reviewSetIndex < this.process.reviewSets.length; reviewSetIndex++) {
                    const reviewSet = this.process.reviewSets[reviewSetIndex];
                    for (let reviewIndex = 0; reviewIndex < reviewSet.reviews.length; reviewIndex++) {
                        const review = reviewSet.reviews[reviewIndex];
                        this.addUpdateReviewDocumentsHandler(reviewSet, review);
                    }
                }
            }

            this.fileUploadModel = new models.FileUploadModel();
            if (this.process) {
                this.fileUploadModel.processId = this.process.id;
            }

            this.showAddReview = false;
            this.currentReviewSet = undefined;
            this.setReviewSet(); 
        }

        private addUpdateReviewDocumentsHandler(reviewSet: Wars.Domain.Model.Dtos.ReviewSetDto, review: Wars.Domain.Model.Dtos.ReviewDto): void {
            this.updateReviewDocumentHandlers[review.id] = (model: models.FileUploadModel) => {
                review.documentIds = this.getDocIds(model.documents);
                this.processService.updateReviewDocuments(this.process.id, reviewSet.id, review.id, review.documentIds);
            }
        }

        public reviewerSelected(item: Wars.Domain.Model.Dtos.UserSearchDto) {
            this.selectedUser = item;
            if (!this.selectedUser)
                return;

            if (this.selectedUser.isExternal) {
                this.userService.addExternalUser(this.selectedUser).then(id => {
                    this.selectedReviewUserId = id;
                });
            } else {
                this.selectedReviewUserId = this.selectedUser.id;
            }
        }

        public userpickerBlurred(): void {
            // Wait for search method call to save off typed in user value
            this.$timeout(() => this.updateErrorMessage(), 300);
        }

        private updateErrorMessage(): void {
            if ((this.selectedUser === undefined || this.selectedUser === null) && (this.typedInUserValue !== undefined && this.typedInUserValue !== null)) {
                this.errorMessage = "No user has been selected from the input above.  Please wait for the autocomplete when searching for a user.";
            }
            else {
                this.errorMessage = undefined;
            }
        }

        public clearUser() {
            this.selectedUser = null;
            this.selectedReviewUserId = null;
        }

        public removeReview(review:Wars.Domain.Model.Dtos.ReviewDto) {
            this.processService.removeReview(this.process.id, this.currentReviewSet.id, review.id).then(r => {
                if (r) {
                    this.currentReviewSet.reviews.remove(review);
                } else {
                    this.growl
                        .error("You can not remove this review because the reviewer has added a comment or you do not have access to perform this function");
                }
            });
        }

        private setReviewSet() {
            if (this.currentReviewSet)
                return;

            if (this.process == null)
                return;

            this.currentReviewSet = Enumerable.from(this.process.reviewSets)
                .single(r => r.reviewConfigurationUniqueId === this.manageSection.reviewConfigurationUniqueIdentifier);
        }

        private getInitialReviewTypeValue(): Wars.Domain.Model.Codes.SystemCode {
            return this.manageSection.reviewConfiguration.codeGroup.codes.length === 1
                ? this.manageSection.reviewConfiguration.codeGroup.codes[0]
                : null;
        }

        private cancelAddReviewer() {
            this.showAddReview = false;
            //clear add reviewer form after adding the selected user.
            this.selectedUser = null;
            this.selectedReviewUserId = null;
            this.dueDate = null;
            this.selectedReviewType = this.getInitialReviewTypeValue();
            this.assignedDate = null;
        }

        private addReviewer() {
            this.setReviewSet();
            if (this.manageSection.reviewConfiguration.allowAssignDateSelection &&
                !this.dateRangeService.doesDateRangePass(this.assignedDate,
                    this.manageSection.reviewConfiguration.beginAssignDateType)) {
                this.growl.error("The assigned date " + this.dateRangeService.dateRangeFailureText(this.manageSection.reviewConfiguration.beginAssignDateType));
                return;
            }

            if (this.manageSection.reviewConfiguration.closingType == Wars.Domain.Model.Codes.Enums.ClosingType.Assigned &&
                !this.dateRangeService.doesDateRangePass(this.dueDate,
                    this.manageSection.reviewConfiguration.endAssignDateType)) {
                this.growl.error("The due date " + this.dateRangeService.dateRangeFailureText(this.manageSection.reviewConfiguration.endAssignDateType));
                return;
            }

            var hasOpenReview = Enumerable.from(this.currentReviewSet.reviews).any(i => i.closedDate == null && i.assignedUserId == this.selectedReviewUserId);
            if (hasOpenReview) {
                this.growl.error("The selected user has an open assignment and cannot be assigned again until the current assignment is closed.");
                return;
            }

            if (this.selectedReviewUserId === null || this.selectedReviewUserId === undefined) {
                this.growl.error("A user must be selected to continue.");
                return;
            }

            this.processService.addReview(this.process.id,
                this.currentReviewSet.id,
                this.selectedReviewUserId,
                this.dueDate,
                this.selectedReviewType,
                this.assignedDate).then(
                    (review) => {
                        this.currentReviewSet.reviews.push(review);
                        this.addUpdateReviewDocumentsHandler(this.currentReviewSet, review);
                        this.showAddReview = false;
                        //clear add reviewer form after adding the selected user.
                        this.selectedUser = null;
                        this.selectedReviewUserId = null;
                        this.dueDate = null;
                        this.selectedReviewType = this.getInitialReviewTypeValue();
                        this.assignedDate = null;
                        //load process dto to show comment button if appropriate
                        var self = this;
                        this.processService.getProcessDto(this.process.id)
                            .then((result) => {
                                self.process
                                    .commentThreads[this.manageSection.reviewConfiguration.commentThreadConfiguration
                                        .uniqueIdentifier].canComment =
                                    result.commentThreads[this.manageSection.reviewConfiguration
                                        .commentThreadConfiguration.uniqueIdentifier].canComment;
                            });
                    });
        }

        private closeReview(review:Wars.Domain.Model.Dtos.ReviewDto) {
            this.processService.closeReview(this.process.id, this.currentReviewSet.id,review.id).then(r => {
                review.isComplete = true;
                if (r && r.data && r.data.closedDate) {
                    review.closedDate = r.data.closedDate;
                    var self = this;
                    this.processService.getProcessDto(this.process.id)
                        .then((result) => {
                            self.process
                            .commentThreads[this.manageSection.reviewConfiguration.commentThreadConfiguration
                            .uniqueIdentifier].canComment =
                            result.commentThreads[this.manageSection.reviewConfiguration
                            .commentThreadConfiguration.uniqueIdentifier].canComment;
                        });
                }
            });
        }

        private reviewConfigurationChanged() {
            this.manageSection.reviewConfigurationUniqueIdentifier = this.manageSection.reviewConfiguration.uniqueIdentifier;
            this.formService.saveAllChanges();
        }

        public saveReviewComment(review: Wars.Domain.Model.Dtos.ReviewDto) {
            this.processService.saveReviewComment(this.process.id, this.currentReviewSet.id,review.id,review.comment);
        }

        public addNewComment(): void {
            this.addingNewComment = true;
            this.newComment = undefined;
            this.newCommentDocIds = [];
            this.newCommentDate = new Date();
        }

        private documentUpdatedInternal(model: models.FileUploadModel): void {
            this.newCommentDocIds = Enumerable.from(model.documents).select(i => i.id).toArray();
        }

        public saveNewComment(): void {
            

            if (this.newComment == undefined || this.newComment == null || this.newComment.trim().length === 0) {
                this.growl.error("New Comment text is required.");
                return;
            }

            if (this.manageSection.reviewConfiguration.commentThreadConfiguration.allowCommentDateToBeSet &&
                this.newCommentDate == null) {
                this.growl.error(this.manageSection.reviewConfiguration.commentThreadConfiguration.commentDateLabel + " is required.");
                return;
            }

            if (this.manageSection.reviewConfiguration.commentThreadConfiguration.allowCommentDateToBeSet &&
                !this.dateRangeService.doesDateRangePass(this.newCommentDate, this.manageSection.reviewConfiguration.commentThreadConfiguration.commentDateRange)) {
                this.growl.error("The " +
                    this.manageSection.reviewConfiguration.commentThreadConfiguration.commentDateLabel
                    + " " +
                    this.dateRangeService.dateRangeFailureText(this.manageSection.reviewConfiguration.commentThreadConfiguration.commentDateRange));

                return;
            }

            this.addingNewComment = false;

            var commentDto: Wars.Domain.Model.Dtos.CommentDto = {
                comment: this.newComment,
                documentIds: this.newCommentDocIds,
                processId: this.process.id,
                manageSectionUniqueId: this.manageSection.uniqueIdentifier,
                reviewSetId: this.currentReviewSet.id,
                commentDate: this.newCommentDate
            };

            this.commentService.createNewCommentThreadEntry(commentDto).then(
                (commentThread) => {
                    if (this.newCommentDocIds && this.process) {
                        this.processDocumentService.updateManageDocumentSections(this.process);
                    }

                    this.process.commentThreads[this.manageSection.reviewConfiguration.commentThreadConfiguration.uniqueIdentifier].threads.push(commentThread);
                    this.addingNewComment = false;
                    this.newComment = undefined;
                    this.newCommentDocIds = [];
                    this.newCommentDate = undefined;
                });
        }

        public cancelNewComment(): void {
            this.newComment = undefined;
            this.addingNewComment = false;
        }

        private searchUsers(viewValue): any {
            this.typedInUserValue = viewValue;
            var searchCriteria = new models.UserSearchCriteria();
            searchCriteria.userRepository = this.manageSection.reviewConfiguration.userServiceName;
            searchCriteria.userName = viewValue;
            return this.userService.searchUsers(searchCriteria);
            //return this.userService.search(searchCriteria);
        }

        public getDocIds(docs: Wars.Domain.Model.Dtos.DocumentDto[]): string[] {
            return docs ? Enumerable.from(docs).select(i => i.id).toArray() : [];
        }
    }

    export class ReviewSectionController {

        constructor(private scope: IReviewSectionScope,
            $timeout: angular.ITimeoutService,
            private formService: services.FormService,
            private reviewConfigurationService: services.ReviewConfigurationService,
            private userService: services.UserService,
            private processService: services.ProcessService,
            private commentService: services.CommentService,
            growl: angular.growl.IGrowlService,
            private dateRangeService: services.DateRangeService,
            private processDocumentService: services.ProcessDocumentService)
        {
            scope.model = new ReviewSectionModel(
                $timeout,
                userService,
                processService,
                formService,
                commentService,
                reviewConfigurationService,
                scope.processConfigurationId,
                scope.isConfigureMode,
                scope.manageSection,
                scope.process,
                growl,
                dateRangeService,
                processDocumentService);

            if (!scope.isConfigureMode) {
                scope.$watch("process",
                    (newValue) => {
                        if (newValue !== undefined && newValue !== null) {
                            scope.model = new ReviewSectionModel(
                                $timeout,
                                userService,
                                processService,
                                formService,
                                commentService,
                                reviewConfigurationService,
                                scope.processConfigurationId,
                                scope.isConfigureMode,
                                scope.manageSection,
                                scope.process,
                                growl,
                                dateRangeService,
                                processDocumentService);
                        } else {
                            scope.model = undefined;
                        }
                    });
            }
        }
    }
}
warsApp.registerDirective('ReviewSection', []);